import makeApiCall from "./axiosIndex";

const sitebreakdownMasterApis = {
  fetchUnitsBySiteId: (params: { siteId: number | string }): Promise<any> => {
    return makeApiCall({
      url: "/buyer/fetchSiteStructureUnitsBySiteId",
      method: "get",
      params,
    });
  },
  fetchFloorNumbersByUnitId: (params: {
    siteId: number | string;
    unitId: number | string;
  }): Promise<any> => {
    return makeApiCall({
      url: "/buyer/fetchFloorNumbersByUnitId",
      method: "get",
      params,
    });
  },
  fetchLocationsBySiteId: (params: {
    siteId: number | string;
  }): Promise<any> => {
    return makeApiCall({
      url: "/buyer/fetchLocationsBySiteId",
      method: "get",
      params,
    });
  },
  fetchSubUnitsByUnitId: (params: {
    siteId: number | string;
    unitId: number | string;
    floorNo?: string;
  }): Promise<any> => {
    return makeApiCall({
      url: "/buyer/fetchSiteStructureSubUnitsByUnitId",
      method: "get",
      params,
    });
  },
  fetchSegmentLevelBySiteId: (params: {
    siteId: number | string;
  }): Promise<any> => {
    return makeApiCall({
      url: "/buyer/fetchSegmentLevelBySiteId",
      method: "get",
      params,
    });
  },
};

export default sitebreakdownMasterApis;
